var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationtriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "red",
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopicon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.229,36.968L25.772,5.001c-0.357-0.619-1.018-1-1.732-1s-1.375,0.381-1.732,1L3.852,36.968 c-0.356,0.619-0.356,1.381,0,2c0.357,0.619,1.018,1,1.732,1h36.912c0.715,0,1.375-0.381,1.732-1 C44.585,38.349,44.585,37.587,44.229,36.968z M9.048,35.968L24.04,10.001l14.992,25.967H9.048z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.998,
    y: 16.001,
    transform: "matrix(1 -0.0039 0.0039 1 -0.0877 0.0939)",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.023,31.124c-0.969,0-1.755,0.786-1.755,1.755c0,0.969,0.786,1.754,1.755,1.754s1.755-0.786,1.755-1.754 C25.778,31.909,24.992,31.124,24.023,31.124z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationtriangle);
export default __webpack_public_path__ + "static/media/exclamationtriangle.2af784456d7fb9f5d9ed21010e9167d1.svg";
export { ForwardRef as ReactComponent };